/**
 * The microphone state owned while a Website Agent is still cold-booting.
 * Permission and desired mute state are deliberately separate: a granted
 * browser prompt does not override a later, explicit second click to mute.
 */
export interface WebsiteAgentMicIntent {
  permissionReady: boolean;
  desiredEnabled: boolean;
}

export type WebsiteAgentMicIntentEvent =
  | { type: 'reset' }
  | { type: 'permission-resolved'; granted: boolean }
  | { type: 'toggle' };

export const EMPTY_WEBSITE_AGENT_MIC_INTENT: WebsiteAgentMicIntent = {
  permissionReady: false,
  desiredEnabled: false,
};

export function reduceWebsiteAgentMicIntent(
  state: WebsiteAgentMicIntent,
  event: WebsiteAgentMicIntentEvent,
): WebsiteAgentMicIntent {
  if (event.type === 'reset') return { ...EMPTY_WEBSITE_AGENT_MIC_INTENT };
  if (event.type === 'permission-resolved') {
    return {
      permissionReady: event.granted,
      desiredEnabled: event.granted,
    };
  }
  return state.permissionReady
    ? { ...state, desiredEnabled: !state.desiredEnabled }
    : state;
}

export function websiteAgentShouldJoinWithMicrophone(
  state: WebsiteAgentMicIntent,
): boolean {
  return state.permissionReady && state.desiredEnabled;
}
